export const searchFilterKeys = [
  'bodyType',
  'colour',
  'seats',
  'doors',
  'fromEngineSize',
  'toEngineSize',
  'fuelType',
  'make',
  'model',
  'trim',
  'mileage',
  'fromPrice',
  'toPrice',
  'rangeInMiles',
  'gearbox',
  'fromYear',
  'toYear',
  'driveType',
  'store',
  'site',
  'tags',
  'features',
  'financeType',
  'vehicleYear',
  'condition',
] as const

export const validUrlSegmentFilterKeys = [
  'bodyType',
  'colour',
  'seats',
  'doors',
  'fuelType',
  'make',
  'model',
  'trim',
  'gearbox',
  'driveType',
  'vehicleYear', // Only allow vehicleYear (not fromYear/toYear) in URL segments
  'rangeInMiles',
] as const

export const nonFilterParamKeys = [
  'sortingCriteria',
  'pageSize',
  'pageNumber',
] as const

export const searchParamKeys = [
  ...searchFilterKeys,
  ...nonFilterParamKeys,
] as const

export const DEFAULT_SORTING_CRITERIA = 3
export const DEFAULT_PAGE_SIZE = 32
